import React from 'react';
import classNames from '@utils/classnames';

import { useTranslation } from '../contexts/translation-context';

export interface InputWrapperProps {
  labelText: React.ReactNode;
  invalidText?: string;
  helperText?: string;
  children: React.ReactNode;
  noLabel?: boolean;
  hideInvalid?: boolean;
  className?: string;
}

const Label: React.FC<{ children: React.ReactNode; noLabel?: boolean }> = (props) => {
  return React.createElement(props.noLabel ? 'div' : 'label', { className: 'block w-full text-left' }, props.children);
};

/** Label above the control, helper / validation text below. */
export const InputWrapper: React.FC<InputWrapperProps> = (props) => {
  const { labelText, invalidText, hideInvalid, helperText, children, noLabel, className } = props;
  const { i18n } = useTranslation();

  return (
    <div className={classNames('w-full', className)}>
      <Label noLabel={noLabel}>
        <div className="label-text mb-1.5 w-full">{labelText}</div>
        <div>{children}</div>
      </Label>

      {!hideInvalid && (
        <div className="mt-1 w-full text-xs">
          {invalidText ? (
            <span className="text-negative-text">{i18n(invalidText as any)}</span>
          ) : (
            <span className="text-fg-muted">{helperText ?? <>&zwnj;</>}</span>
          )}
        </div>
      )}
    </div>
  );
};
